import {Field, Form, Formik} from 'formik'
import * as Yup from 'yup'

import {useIntl} from 'react-intl'
import Logo from '../../../_metronic/assets/logo-white.png'
import BG from '../asset/login-3.png'
import {LanguageList} from '../helper/languageList'
import {useForgotPassword} from '../context/useMutation'
import {GoogleReCaptchaCheckbox} from 'react-google-recaptcha-ultimate'
import {useState} from 'react'
import './style.css'

export default function ForgotPassword() {
  const intl = useIntl()
  const {mutateAsync, isLoading} = useForgotPassword()
  const [oldgoogleRecaptcha, setOldGoogleRecaptcha] = useState<string>('')

  const validationSchema = Yup.object({
    email: Yup.string()
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    recaptcha: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.RECAPTCHA'})),
  })

  // const submit = async (values: any) => {
  //   handlesubmit(values)
  // }

  const handleSubmit = async (values: any) => {
    setOldGoogleRecaptcha(values.recaptcha)
    mutateAsync({
      values,
      recaptcha: oldgoogleRecaptcha,
    })
  }

  const handleExpired = (setFieldValue) => {
    setOldGoogleRecaptcha('')
    setFieldValue('recaptcha', '')
    if (typeof document !== 'undefined' && (window as any).grecaptcha) {
      ;(window as any).grecaptcha.reset()
    }
  }

  return (
    <>
      <div
        className='d-flex flex-column flex-root w-100 justify-content-center align-items-center'
        id='kt_app_root'
      >
        <div
          className='d-flex flex-column flex-lg-row justify-content-between h-100 w-100 position-relative'
          id='loginBg'
        >
          <div
            className='d-flex flex-column w-100 h-100 p-20 justify-content-center align-items-center'
            id='login-right'
          >
            <div
              className='d-flex align-items-center justify-content-center flex-column gap-20'
              style={{
                width: '80%',
              }}
            >
              <div className='w-100 d-flex justify-content-between align-items-center'>
                <div className=''>
                  <a
                    href={process.env.REACT_APP_DEJAVOOEXTRA}
                    className='d-block d-lg-none mx-auto pt-10'
                  >
                    <img alt='Logo' src={Logo} className='h-25px' />
                  </a>

                  <div className='d-flex flex-column gap-4'>
                    <div className='d-none d-md-block'>
                      <a href={process.env.REACT_APP_DEJAVOOEXTRA}>
                        <img alt='Extra360 - Partner Portal' className='h-50px' src={Logo} />
                      </a>
                    </div>
                    <h1 className='fs-1 fw-normal text-white' data-kt-translate='sign-in-title'>
                      {intl.formatMessage({id: 'APP_NAME'})}
                    </h1>
                  </div>

                  <div className='mt-10 w-75'>
                    <h1 className='text-white fs-3x fw-normal'>
                      Unlock New Growth and Elevate Your Business Success with Vasco
                    </h1>
                  </div>

                  <div
                    className='d-flex'
                    style={{
                      marginTop: '5rem',
                    }}
                  >
                    <a
                      className='d-flex align-items-center justify-content-between text-white'
                      href='/become-a-merchant/merchant-form'
                    >
                      <span className='fs-4 fw-bold'>
                        {intl.formatMessage({id: 'AUTH.LOGIN.BECOME_MERCHANT'})}
                      </span>

                      <i className='bi bi-arrow-right fs-2 text-white ms-3'></i>
                    </a>
                  </div>
                </div>

                <div
                  className='card ps-5 d-flex flex-column justify-content-center'
                  style={{
                    minHeight: '600px',
                    width: '50%',
                  }}
                >
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={{
                      email: '',
                      recaptcha: '',
                    }}
                    // onSubmit={handleSubmit}
                    onSubmit={handleSubmit}
                  >
                    {({errors, touched, setFieldValue}) => (
                      <Form className='form w-100'>
                        <div className='card-body'>
                          <div className='text-start mb-10'>
                            <h1 className='mb-3 fs-3x' data-kt-translate='sign-in-title'>
                              {intl.formatMessage({id: 'AUTH.FORGOT.TITLE'})}
                            </h1>

                            <div
                              className='fw-semibold fs-6'
                              data-kt-translate='password-reset-desc'
                            >
                              {intl.formatMessage({id: 'AUTH.FORGOT.DESC'})}
                            </div>
                          </div>

                          <div className='fv-row mb-8 form-floating w-75'>
                            <Field
                              type='text'
                              name='email'
                              className='form-control bg-transparent'
                              placeholder={intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
                              maxLength={101}
                            />
                            <label>{intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}</label>
                            {errors.email && touched.email && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.email}</div>
                              </div>
                            )}
                          </div>

                          <div className='mb-7'>
                            <GoogleReCaptchaCheckbox
                              action='FORGOT_PASSWORD'
                              callback={(token) => {
                                setFieldValue('recaptcha', token)

                                setTimeout(() => {
                                  handleExpired(setFieldValue)
                                }, 60000)
                              }}
                            />
                            {errors.recaptcha && touched.recaptcha ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.recaptcha}</div>
                              </div>
                            ) : null}
                          </div>

                          <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-10 w-75'>
                            <div className='m-0'>
                              <button
                                // id='kt_password_reset_submit'
                                disabled={isLoading}
                                type='submit'
                                className='btn btn-primary me-2'
                                // data-kt-translate='password-reset-submit'
                              >
                                {isLoading ? (
                                  <span data-kt-translate='general-progress'>
                                    {intl.formatMessage({id: 'LOADING'})}
                                  </span>
                                ) : (
                                  <>
                                    <i className='bi bi-arrow-right me-3 fs-3'></i>
                                    <span className='indicator-label'>
                                      {intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
                                    </span>
                                  </>
                                )}
                              </button>
                              <a
                                href='sign-in'
                                className='btn fw-bold'
                                data-kt-translate='password-reset-cancel'
                              >
                                {intl.formatMessage({id: 'AUTH.GENERAL.BACK_BUTTON'})}
                              </a>
                            </div>
                          </div>
                          {/*     <div className='mt-10'>
                            <LanguageList />
                          </div> */}
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
